import _extends from '@babel/runtime/helpers/extends';
import React__default from 'react';
import styled, { css } from 'styled-components';
import { i as isMobile } from '../../theme/style-mixins/isMobile/isMobile-CGsYoba7.js';
import { D as Divider } from '../../Divider/Divider-BXwzMerK.js';
import { T as Text } from '../../Text/Text-CO4HftGt.js';
import { S as StyledList } from '../MenuList/MenuList-DWWFze0c.js';
import { T as TaktIdProvider } from '../../TaktIdContext/TaktIdContext-C6vdL-6Z.js';
import { c as createStormTaktId } from '../../TaktIdContext/TaktIdContext.utils-B0CzqlN8.js';

const MenuDivider = /*#__PURE__*/styled(Divider).withConfig({
  componentId: "sc-storm-ui-40026394__sc-pf1wj0-0"
})(["margin:0;"]);
MenuDivider.displayName = 'MenuDivider';
const MenuItemGroupListItem = /*#__PURE__*/styled('li').withConfig({
  componentId: "sc-storm-ui-40026394__sc-pf1wj0-1"
})(["text-align:start;:first-child ", "{display:none;};"], MenuDivider);
MenuItemGroupListItem.displayName = 'MenuItemGroupListItem';
const MenuItemGroupLabel = /*#__PURE__*/styled(Text).withConfig({
  componentId: "sc-storm-ui-40026394__sc-pf1wj0-2"
})(["display:inline-block;user-select:none;font-weight:", ";padding-inline:", ";padding-block:", ";", ""], ({
  theme
}) => theme.font.weight.bold, ({
  theme
}) => theme.controls.paddingInline.xlarge.default, ({
  theme
}) => theme.spacing.xxsmall.default, isMobile(css(["padding-inline:", ";padding-block:", ";"], ({
  theme
}) => theme.controls.paddingInline.xlarge.mobile, ({
  theme
}) => theme.spacing.xxsmall.default)));
MenuItemGroupLabel.displayName = 'MenuItemGroupLabel';
const MenuItemGroup = ({
  children,
  label,
  onClick,
  taktId,
  taktValue,
  ...rest
}) => /*#__PURE__*/React__default.createElement(TaktIdProvider, {
  taktId: taktId,
  taktValue: taktValue,
  fallbackId: createStormTaktId('menu-item-group')
}, /*#__PURE__*/React__default.createElement(MenuItemGroupListItem, _extends({}, rest, {
  role: "group"
}), /*#__PURE__*/React__default.createElement(MenuDivider, null), label && /*#__PURE__*/React__default.createElement(MenuItemGroupLabel, {
  renderAs: "span"
}, label), /*#__PURE__*/React__default.createElement(StyledList, null, children)));

export { MenuItemGroup as M };
//# sourceMappingURL=MenuItemGroup-Bpo99QjI.js.map
